import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import {
  AppointmentDto,
  AppointmentStatus,
  PropertyApplicationDto,
  PropertyDto,
} from '@workspace/data-types';
import { LuxonDatePipe } from '@workspace/ng-aura';

export interface PropertyVisitDetailsDialogData {
  appointment: AppointmentDto;
  property?: PropertyDto | null;
  application?: PropertyApplicationDto | null;
}

@Component({
  selector: 'etxe-property-visit-details-dialog',
  imports: [MatDialogModule, MatButtonModule, MatIconModule, LuxonDatePipe],
  templateUrl: './property-visit-details-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyVisitDetailsDialogComponent {
  readonly dialogRef = inject(MatDialogRef<PropertyVisitDetailsDialogComponent>);
  readonly data = inject<PropertyVisitDetailsDialogData>(MAT_DIALOG_DATA);
  private readonly router = inject(Router);

  readonly appointment = this.data.appointment;
  readonly property = this.data.property;
  readonly application = this.data.application;

  openAgenda(): void {
    this.dialogRef.close();
    const appt = this.appointment;
    const slot = appt?.confirmedSlot || appt?.proposedSlots?.[0];
    let targetDate: string | undefined;
    if (slot?.startAt) {
      const d = new Date(slot.startAt);
      if (!Number.isNaN(d.getTime())) {
        targetDate = d.toISOString();
      }
    }
    const apptId = appt?._id ? String(appt._id) : undefined;
    const isConfirmed =
      appt?.status === AppointmentStatus.CONFIRMED || (appt?.status as string) === 'confirmed';

    void this.router.navigate(['/agenda'], {
      queryParams: {
        ...(apptId ? { appointmentId: apptId } : {}),
        ...(targetDate ? { date: targetDate } : {}),
        view: 'week',
        filter: isConfirmed ? 'confirmed' : 'all',
      },
    });
  }

  openDiscussion(): void {
    this.dialogRef.close();
    const discussionId = this.application?.discussion;
    if (discussionId) {
      void this.router.navigate(['/messages', discussionId]);
    } else {
      void this.router.navigate(['/messages']);
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}
